var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-context-menu',{ref:"menu",attrs:{"title":"FRAME-EDITOR-MENU","color":"warning darken-1","max-height":"400","items":_vm.items}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }